import Vue from "vue";
import OrderHistory from "../../../app/components/myAccount/OrderHistory";
import MyAccountConfig from "./AccountConfig";

export default Vue.component("history", {

    components:
    {
        OrderHistory,
        MyAccountConfig
    },

    props: {
        template: String,
        ordersPerPage: Number,
        isReturnActive: Boolean,
        contactHasReturns: Boolean
    },

    data()
    {
        return {
            myAccountTabOpened: false
        };
    },

    methods:
    {
        myAccountTabOpen()
        {
            if (!this.myAccountTabOpened)
            {
                this.myAccountTabOpened = true;

                vueEventHub.$emit("myAccountTab-opening");
            }
        }
    }
});
